/* History */
export const HISTORY_GO_BACK = 'HISTORY_GO_BACK';
export const HISTORY_GO_BACK_SUCCESS = 'HISTORY_GO_BACK_SUCCESS';
export const HISTORY_GO_BACK_FAILED = 'HISTORY_GO_BACK_FAILED';
export const NAVIGATE_TO_PATH = 'NAVIGATE_TO_PATH';

/* Print */
export const PRINT = 'PRINT';
export const PRINT_SUCCESS = 'PRINT_SUCCESS';
export const PRINT_FAILED = 'PRINT_FAILED';

/* Input */
export const INPUT_KEYWORD = 'INPUT_KEYWORD';

/* Menu */
export const OPEN_MENU = 'OPEN_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';
export const OPEN_SUB_MENU = 'OPEN_SUB_MENU';
export const CLOSE_SUB_MENU = 'CLOSE_SUB_MENU';
